import { Alert, AutoComplete, Button, Card, Checkbox, Col, Flex, Form, Image, Input, InputNumber, message, Modal, Radio, Row, Select, Space, Typography, Upload } from "antd";
import { kategoriPeruntukanRegistrasi, peruntukanRegistrasi } from "../../utils/options.data";
import { useEffect, useState } from "react";
import UploadFileRenderer from "../../components/FileUploadRenderer";
import { Icon } from "@iconify/react";
import CardFooterAction from "../../components/CardFooterAction";
import { useMutation, useQuery } from "@tanstack/react-query";
import { registrationService } from "../../services/registration.service";
import { useNavigate } from "react-router";
import RenderIf from "../../components/RenderIf";
import { indonesiaRegionService } from "../../services/indonesia-region.service";
import { MAX_FILE_SIZE } from "../../utils/const";
import pallete from "../../utils/pallete";
import { canUploadImage } from "../../utils/imageValidator";
import MapComponent from "../../components/Maps";
import useDebounce from "../../hooks/useDebounce";
import { mapsService } from "../../services/maps.service";


const addressNumberFormatter = {
  formatter: (value) => {
    const numericValue = value.replace(/\D/g, '');

    if (numericValue) {
      return numericValue.padStart(3, '0');
    }
    return '';
  },
  parser: (value) => {
    return value.replace(/\D/g, '');
  }
}

export default function SurveyForm() {

  const navigate = useNavigate()

  const [messageApi, contextHolder] = message.useMessage()
  const [form] = Form.useForm()

  const [peruntukanBangunanFilter, setPeruntukanBangunanFilter] = useState([])
  const [ktp, setKtp] = useState([])
  const [kk, setKk] = useState([])
  const [pbb, setPbb] = useState([])
  const [bangunan, setBangunan] = useState([])

  const [selectedAddress, setSelectedAddress] = useState('')
  const [searchAddress, setSearchAddress] = useState('')

  const [selectedCity, setSelectedCity] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [filePrev, setFilePrev] = useState('')
  const [checkABStatus, setCheckABStatus] = useState({
    valid: false,
    ab: null,
    surveyorAB: []
  })

  const addressDebounce = useDebounce(searchAddress, 300)

  const [position, setPosition] = useState([-6.1995, 106.8118])

  const [errors, setErrors] = useState({
    ktp: false,
    kk: false,
    pbb: false,
    bangunan: false,
  })

  const kategoriBangunanWatch = Form.useWatch('kategori_bangunan', form)
  const picCheck = Form.useWatch('customer_pic', form)
  const city = Form.useWatch('kota_kustomer', form)
  const district = Form.useWatch('kecamatan_kustomer', form)

  useEffect(() => {
    if (kategoriBangunanWatch) {
      setPeruntukanBangunanFilter(peruntukanRegistrasi.filter(e => e.kategori == kategoriBangunanWatch))
    }
  }, [kategoriBangunanWatch, form])

  useEffect(() => {
    if (picCheck) {
      const customerFields = ['nama_kustomer', 'nomor_kustomer', 'email_kustomer', 'kota_kustomer', 'kelurahan_kustomer', 'kecamatan_kustomer', 'jalan_kustomer', 'no_rumah_kustomer', 'rt_kustomer', 'rw_kustomer'];
      const data = form.getFieldsValue(customerFields)
      form.setFieldValue('nama_pic', data.nama_kustomer)
      form.setFieldValue('nomor_pic', data.nomor_kustomer)
      form.setFieldValue('email_pic', data.email_kustomer)
      form.setFieldValue('kota_pic', data.kota_kustomer)
      form.setFieldValue('kelurahan_pic', data.kelurahan_kustomer)
      form.setFieldValue('kecamatan_pic', data.kecamatan_kustomer)
      form.setFieldValue('jalan_pic', data.jalan_kustomer)
      form.setFieldValue('no_rumah_pic', data.no_rumah_kustomer)
      form.setFieldValue('rt_pic', data.rt_kustomer)
      form.setFieldValue('rw_pic', data.rw_kustomer)
    }
  }, [form, picCheck])

  const { data: cities } = useQuery({
    queryKey: ['cities'],
    queryFn: () => indonesiaRegionService.getCities(),
  })

  const { data: districts } = useQuery({
    queryKey: ['districts', selectedCity],
    queryFn: () => indonesiaRegionService.getDistricts(selectedCity),
    enabled: !!city
  })

  const { data: villages } = useQuery({
    queryKey: ['villages', selectedDistrict],
    queryFn: () => indonesiaRegionService.getSubdistricts(selectedDistrict),
    enabled: !!district
  })

  const { data: addressResponse } = useQuery({
    queryKey: ['searchAddress', addressDebounce],
    queryFn: () => mapsService.searchAddress(addressDebounce),
    enabled: !!addressDebounce
  })

  const checkSuryeyorABMutation = useMutation({
    mutationFn: (body) => registrationService.checkSurveyorAB(body),
    onSuccess: ({ data }) => {
      setCheckABStatus(data)
    },
    onError: (err) => {
      messageApi.error(err?.response?.data?.message || "Terjadi Kesalahan")
    }
  })

  const reverseGeocodeMutation = useMutation({
    mutationFn: (coords) => {
      setCheckABStatus({
        valid: false,
        ab: null,
        surveyorAB: []
      })
      const lat = coords?.lat ?? position[0];
      const lng = coords?.lng ?? coords?.lon ?? position[1];
      return mapsService.reverseGeocode(lat, lng);
    },
    onSuccess: (data) => {
      setSelectedAddress(data.display_name)
      form.setFieldsValue({ alamat_bangunan: data.display_name, latitude: Number(data.lat), longitude: Number(data.lon), kode_pos: data?.address?.postcode });
      checkSuryeyorABMutation.mutate({ latitude: data.lat, longitude: data.lon })
    }
  })

  useEffect(() => {

    form.resetFields(['kecamatan_kustomer', 'kelurahan_kustomer'])

    if (city) {
      const selected = cities.find(e => e.name == city)
      setSelectedCity(selected?.id)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city])

  useEffect(() => {

    form.resetFields(['kelurahan_kustomer'])

    if (district) {
      const selected = districts.find(e => e.name == district)
      setSelectedDistrict(selected?.id)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [district])


  const storeMutation = useMutation({
    mutationFn: val => registrationService.store(val),
    onSuccess: () => {
      message.success("Data Berhasil ditambah")
      return navigate("/survey")
    },
    onError: err => {
      message.error("Terjadi Kesalahan")
      console.log(err)
    }
  })

  const toggleError = (field, error = true) => {
    setErrors({ ...errors, [field]: error })
  }

  const handleSubmit = (val) => {

    let newErrors = {
      ktp: ktp.length === 0,
      kk: kk.length === 0,
      bangunan: bangunan.length === 0
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(error => error);

    if (hasErrors) {
      return;
    }

    storeMutation.mutate({
      ...val,
      ktp: ktp[0],
      kk: kk[0],
      pbb: pbb[0],
      bangunan: bangunan[0]
    })
  }
  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const preprocessUpload = async (file) => {
    file.preview = await getBase64(file)
    if (!canUploadImage(file.name)) {
      message.error(`Format file tidak benar`);
      return Upload.LIST_IGNORE; // 
    }
    if (file.size > MAX_FILE_SIZE) {
      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
      return Upload.LIST_IGNORE; // Mencegah upload
    }
  }

  const handleSelectAddress = (val) => {
    const selected = addressResponse?.find(e => e.display_name == val)
    setSelectedAddress(selected.display_name)
    setPosition([Number(selected.lat), Number(selected.lon)])
    form.setFieldValue('latitude', Number(selected.lat))
    form.setFieldValue('longitude', Number(selected.lon))
  }

  const handleUseCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition([pos.coords.latitude, pos.coords.longitude])
        form.setFieldValue('latitude', pos.coords.latitude)
        form.setFieldValue('longitude', pos.coords.longitude)
        reverseGeocodeMutation.mutate({ lat: pos.coords.latitude, lon: pos.coords.longitude })
      },
      (error) => {
        message.error("Gagal mendapatkan lokasi saat ini")
        console.log(error)
      }
    )
  }

  return (
    <>
      {contextHolder}
      <Card
        title="Tambah Sambungan"
        actions={[
          <CardFooterAction
            key={1}
            onClick={() => form.submit()}
            route={'/survey'}
            loading={storeMutation.isPending}
            disabled={storeMutation.isPending}
            disabledSave={!checkABStatus?.valid}
          />
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={[20]} >
            <Col span={24} >
              <Form.Item
                label="Nama Calon Pelanggan"
                name={'nama_kustomer'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24} >
              <Form.Item
                label="No Handphone Calon Pelanggan"
                name={'nomor_kustomer'}
                rules={[{ required: true }]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24} >
              <Form.Item
                label="Email Calon Pelanggan"
                name={'email_kustomer'}
                rules={[{ required: true, type: 'email' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} >
              <Form.Item
                label="Kota"
                name={'kota_kustomer'}
                rules={[{ required: true }]}
              >
                <Select
                  options={cities?.map(e => ({ label: e.name, value: e.name }))}
                  onChange={(val) => {
                    const selected = cities.find(e => e.name === val);
                    setSelectedCity(selected?.id); // <- simpan ID-nya
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} >
              <Form.Item
                label="Kecamatan"
                name={'kecamatan_kustomer'}
                rules={[{ required: true }]}
              >
                <Select
                  options={districts?.map(e => ({ label: e.name, value: e.name }))}
                  onChange={(val) => {
                    const selected = districts.find(e => e.name === val);
                    setSelectedDistrict(selected?.id); // <- simpan ID-nya
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} >
              <Form.Item
                label="Kelurahan"
                name={'kelurahan_kustomer'}
                rules={[{ required: true }]}
              >
                <Select
                  options={villages?.map(e => ({ label: e.name, value: e.name }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} >
              <Form.Item
                label="Jalan"
                name={'jalan_kustomer'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="No Rumah"
                name={'no_rumah_kustomer'}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6} >
              <Form.Item
                label="RT"
                name={'rt_kustomer'}
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  {...addressNumberFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={6} >
              <Form.Item
                label="RW"
                name={'rw_kustomer'}
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  {...addressNumberFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={24} >
              <Form.Item
                name={'customer_pic'}
                valuePropName="checked"
              >
                <Checkbox>
                  Checklist apabila Nama Penanggung Jawab sama dengan Nama Calon Pelanggan
                </Checkbox>
              </Form.Item>
            </Col>
            <Col span={24} >
              <Form.Item
                label="Nama Penanggung Jawab"
                name={'nama_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24} >
              <Form.Item
                label="No Handphone Penanggung Jawab"
                name={'nomor_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} type="number" readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24} >
              <Form.Item
                label="Email Penanggung Jawab"
                name={'email_pic'}
                rules={[{ required: true, type: 'email' }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="Kota"
                name={'kota_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="Kecamatan"
                name={'kecamatan_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="Kelurahan"
                name={'kelurahan_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="Jalan"
                name={'jalan_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="No Rumah"
                name={'no_rumah_pic'}
                rules={[{ required: true }]}
              >
                <Input style={{ backgroundColor: picCheck && pallete.grey[200] }} readOnly={picCheck} />
              </Form.Item>
            </Col>
            <Col span={6} >
              <Form.Item
                label="RT"
                name={'rt_pic'}
                rules={[{ required: true }]}
              >
                <InputNumber
                  readOnly={picCheck}
                  style={{ width: '100%', backgroundColor: picCheck && pallete.grey[200] }}
                  {...addressNumberFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={6} >
              <Form.Item
                label="RW"
                name={'rw_pic'}
                rules={[{ required: true }]}
              >
                <InputNumber
                  readOnly={picCheck}
                  style={{ width: '100%', backgroundColor: picCheck && pallete.grey[200] }}
                  {...addressNumberFormatter}
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24} >
              <Form.Item
                label="Kebutuhan Air"
                name={'kebutuhan_air'}
                rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Radio style={{ marginRight: 120 }} value={'≤ 500'} >{'≤ 500 m³'}</Radio>
                  <Radio value={'> 500'} >{'> 500 m³'}</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col sm={12} xs={24} >
              <Form.Item
                label="Ketersediaan Tangki"
                name={'ketersediaan_tangki'}
                rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Radio style={{ marginRight: 120 }} value="Ya" >Ya</Radio>
                  <Radio value="Tidak" >Tidak</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24} >
              <Form.Item
                label="Kategori Bangunan"
                name={'kategori_bangunan'}
                rules={[{ required: true }]}
              >
                <Select
                  options={kategoriPeruntukanRegistrasi.map(e => ({ label: e, value: e }))}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={24} >
              <Form.Item
                label="Peruntukan Bangunan"
                name={'peruntukan_bangunan'}
                rules={[{ required: true }]}
              >
                <Select
                  options={peruntukanBangunanFilter.map(e => ({ label: e.peruntukanBangunan, value: e.peruntukanBangunan }))}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={24} >
              <Flex align="end" gap={10} style={{ marginBottom: 18 }} >
                <Form.Item
                  label="Titik Lokasi Bangunan"
                  name={'alamat_bangunan'}
                  rules={[{ required: true }]}
                  style={{ flex: 1, margin: 0 }}
                >
                  <AutoComplete
                    value={selectedAddress}
                    onSearch={setSearchAddress}
                    onSelect={handleSelectAddress}
                    options={addressResponse?.map(e => (
                      {
                        value: e.display_name,
                        label: (
                          <Space direction="vertical" size={3} >
                            <Typography.Text style={{ fontSize: 12, fontWeight: 600, margin: 0 }} >
                              {e.name}
                            </Typography.Text>
                            <Typography.Text style={{ fontSize: 12, color: pallete.grey[700], margin: 0 }} >
                              {e.display_name}
                            </Typography.Text>
                          </Space>
                        )
                      }
                    ))}
                  />
                </Form.Item>
                <Button onClick={handleUseCurrentLocation} variant="solid" color="primary" icon={<Icon width={20} icon={'duo-icons:location'} />} >
                  Gunakan Titik Saat Ini
                </Button>
              </Flex>
              <Card styles={{ body: { padding: 0 } }} >
                <MapComponent
                  position={position}
                  setPosition={setPosition}
                  reverseGeocodeMutation={reverseGeocodeMutation.mutate}
                />
                <RenderIf when={checkABStatus?.ab && !checkABStatus?.valid} >
                  <Alert
                    style={{ marginTop: 10 }}
                    // message="Informasi"
                    description={
                      <>
                        <Typography.Text style={{ display: 'block' }} >
                          Titik lokasi bangunan berada di {checkABStatus?.ab}
                        </Typography.Text>
                        <Typography.Text style={{ display: 'block' }} >
                          Area surveyor : {checkABStatus?.surveyorAB?.join(', ')}
                        </Typography.Text>
                      </>
                    }
                    type={checkABStatus?.valid ? 'success' : 'error'}
                    showIcon
                  />
                </RenderIf>
                <Form.Item hidden name={'kode_pos'} >
                  <Input />
                </Form.Item>
              </Card>
            </Col>
            <Col span={12} >
              <Form.Item hidden name={'latitude'} >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item hidden name={'longitude'} >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24} >
              <Space size={20} direction="vertical" style={{ width: '100%', marginTop: 18 }} >
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={ktp.length > 0}
                  beforeUpload={async (file) => {
                    await preprocessUpload(file)
                    setKtp([file])
                    toggleError('ktp', false)
                    return false
                  }}
                  fileList={ktp}
                  onRemove={() => {
                    setKtp([])
                    toggleError('ktp', true)
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      onPreview={() => setFilePrev(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                          *
                        </Typography.Text>
                        Fotocopy KTP Calon Pelanggan
                      </Typography.Text>
                      <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={ktp.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                  <RenderIf when={errors.ktp} >
                    <Typography.Text type="danger" style={{ display: 'block', marginTop: 10 }} >
                      File tidak boleh kosong
                    </Typography.Text>
                  </RenderIf>
                </Upload>
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={kk.length > 0}
                  beforeUpload={async (file) => {
                    await preprocessUpload(file)
                    setKk([file])
                    toggleError('kk', false)
                    return false
                  }}
                  fileList={kk}
                  onRemove={() => {
                    setKk([])
                    toggleError('kk', true)
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      onPreview={() => setFilePrev(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                          *
                        </Typography.Text>
                        Fotocopy Kartu Keluarga Calon Pelanggan
                      </Typography.Text>
                      <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={kk.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                  <RenderIf when={errors.kk} >
                    <Typography.Text type="danger" style={{ display: 'block', marginTop: 10 }} >
                      File tidak boleh kosong
                    </Typography.Text>
                  </RenderIf>
                </Upload>
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={pbb.length > 0}
                  beforeUpload={async (file) => {
                    await preprocessUpload(file)
                    setPbb([file])
                    toggleError('pbb', false)
                    return false
                  }}
                  fileList={pbb}
                  onRemove={() => {
                    setPbb([])
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      onPreview={() => setFilePrev(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        Fotocopy PBB
                      </Typography.Text>
                      <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={pbb.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                  <RenderIf when={errors.pbb} >
                    <Typography.Text type="danger" style={{ display: 'block', marginTop: 10 }} >
                      File tidak boleh kosong
                    </Typography.Text>
                  </RenderIf>
                </Upload>
                <Upload
                  style={{ width: '100%', display: 'block' }}
                  rootClassName="survey-upload"
                  disabled={bangunan.length > 0}
                  beforeUpload={async (file) => {
                    await preprocessUpload(file)
                    setBangunan([file])
                    toggleError('bangunan', false)
                    return false
                  }}
                  fileList={bangunan}
                  onRemove={() => {
                    setBangunan([])
                    toggleError('bangunan', true)
                  }}
                  itemRender={(_, file, filelist, action) => (
                    <UploadFileRenderer
                      file={file}
                      action={action}
                      onPreview={() => setFilePrev(file.preview)}
                    />
                  )}
                >
                  <Flex justify="space-between" >
                    <div style={{ flex: 1 }} >
                      <Typography.Text style={{ display: 'block' }} >
                        <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                          *
                        </Typography.Text>
                        Foto Bangunan (Tampak Depan)
                      </Typography.Text>
                      <Typography.Text type="secondary" >
                        File jpeg, png, jpg, Max. file size: 2 MB
                      </Typography.Text>
                    </div>
                    <Button
                      icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                      disabled={bangunan.length != 0}
                    >
                      Upload
                    </Button>
                  </Flex>
                  <RenderIf when={errors.bangunan} >
                    <Typography.Text type="danger" style={{ display: 'block', marginTop: 10 }} >
                      File tidak boleh kosong
                    </Typography.Text>
                  </RenderIf>
                </Upload>
              </Space>
            </Col>
          </Row>
        </Form>
      </Card>
      <Modal
        title="Preview File"
        open={filePrev}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setFilePrev(null)}>
            Cancel
          </Button>
        ]}
      >
        <Image src={filePrev} />
      </Modal>
    </>
  )
}